import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class ChangeNavigationService {

    private NavigationUsedSubject: Subject<boolean> = new Subject<boolean>();

    get NavigationUsedEmitter() {
        return this.NavigationUsedSubject;
    }

    hasNavigated() { 
        this.NavigationUsedSubject.next(true);
    }

}